export default __webpack_public_path__ + "static/media/mentalhealth.51bf65ec.svg";